import ensurePath from './ensure-path'
import getCategories from './get-categories'
import { uploadFile } from './upload-file'

export const uploadFileToPath = async (
  file: File,
  path: string,
  category: string
): Promise<string> => {
  const folder = await ensurePath(path)
  if (!folder) {
    throw new Error('Folder not found')
  }
  const categories = await getCategories()
  const matchedCategory = categories.find(({ name }) =>
    name.toLowerCase().includes(category)
  )
  if (!matchedCategory) {
    throw new Error('Category not found')
  }
  return await uploadFile(
    file,
    folder.id,
    file.name,
    matchedCategory.categoryId,
    matchedCategory.name
  )
}
